import { Injectable } from '@angular/core';
import { OrganizationService } from '@nimmsta/ng-commons-lib/services/organization';

@Injectable({ providedIn: 'root' })
export class OrganizationNameService extends OrganizationService {}
